import {
  ALL_ACCESS_PROFILE_ROLE,
  ProfileRoleType,
  TABLET_ONLY_PROFILE_ROLE,
  CRICKET_BOWLING_COACH_PROFILE_ROLE,
  READ_ONLY_CORE_LIBRARY_PROFILE_ROLE,
  TEAM_COACH_PROFILE_ROLE,
  COACH_PROFILE_ROLE,
  COACH_ADMIN_PROFILE_ROLE,
} from '@strength/domain';

export const PROFILE_ROLE_LABELS: Record<ProfileRoleType, string> = {
  [ALL_ACCESS_PROFILE_ROLE]: 'All Access',
  [TABLET_ONLY_PROFILE_ROLE]: 'Tablet Only',
  [CRICKET_BOWLING_COACH_PROFILE_ROLE]: 'Cricket Bowling Coach',
  [READ_ONLY_CORE_LIBRARY_PROFILE_ROLE]: 'Read Only Core Library',
  [TEAM_COACH_PROFILE_ROLE]: 'Team Coach',
  [COACH_PROFILE_ROLE]: 'Coach',
  [COACH_ADMIN_PROFILE_ROLE]: 'Coach Admin',
};

export type CoachProfile = {
  id: string;
  givenName: string;
  familyName: string;
  email: string;
};

export type ProfileRoleAssignment = {
  id: string;
  profileId: string;
  role: ProfileRoleType;
};
